import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Color } from '../../theme/color'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px 0 54px;
`

export const BannerCard = styled.div`
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1 / 0.22;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const SwiperWrap = styled.div`
  overflow: hidden;
  position: relative;
  width: calc(100% - 16px * 2);
  margin: 0 16px;
  border-radius: 8px;
`

export const BannerCountBox = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 1;
  padding: 2px 10px;
  border-radius: 50vh;
  background-color: rgba(0, 0, 0, 0.6);
`

export const FirstGuideContainer = styled(Link)`
  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    width: 100%;
    margin: 0 16px;
  }
  .notify-icon-box {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: ${Color.white};
  }
  .text-box {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
`

export const ContentTitle = styled.div`
  display: flex;
  align-items: center;
`

// export const HistoryCardContainer = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   column-gap: 16px;
//   > div {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     & > div {
//       display: flex;
//       flex-direction: column;
//       gap: 2px;
//     }
//   }
// `

// export const HistoryContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
//   margin: 0 16px;
// `

export const ContentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${ContentTitle} {
    padding-left: 16px;
    > a {
      display: flex;
      align-items: center;
    }
  }
`

export const ContentList = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
  > .swiper {
    padding: 0 16px;
    .swiper-slide {
      width: fit-content;
    }
  }
`
